























































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { Data } from "@/data/data";
import { News } from "@/data/news/news";
import { Document } from "@/model/document2/document";
import FileOpen2 from "@/commonComponents/fileOpen2/fileOpen2.vue";
import MultiFileConverter from '@/commonComponents/multiFileConverter/multiFileConverter.vue';
import { FileHelper } from "@/helper/fileHelper";
import { RequestHelper } from "@/helper/requestHelper";
import { UuidHelper } from '@/helper/uuidHelper';
import { CloudHelper } from "@/helper/cloudHelper";

import { EncryptionHelper } from "@/helper/encryptionHelper";
import { DebugHelper } from "@/helper/debugHelper";
// TEST
import { FileConverter } from "@/label_convert/fileConverter";

import { CookieHelper } from "@/helper/cookieHelper";

import Profile from "./profile/profile.vue";
import InsertionModal from "./insertionModal/insertionModal.vue";
import NewsView from "./newsView/newsView.vue";
import ColorSkin from "./colorSkin/colorSkin.vue";
import License from "./license/license.vue";
import CloudSigninBalloon from "./cloudSigninBalloon/cloudSigninBalloon.vue";
import CloudSignoutBalloon from "./cloudSigninBalloon/cloudSignoutBalloon.vue";

import { Const } from "@/const";

import { LogHelper } from "@/helper/logHelper";
import { InsertionHelper } from "@/helper/insertionHelper";
import { CompatibleHelper } from '@/helper/compatibleHelper';
import { ImageHelper } from '@/helper/imageHelper';

import { newsApi } from "@/api";

//.vueイメージ
import Import from "../resources/import.vue";
import FileOpenButton from "../resources/fileOpenButton.vue";
import CreateNew from "../resources/createNew.vue";
import Book from "../resources/book.vue";
import ProfileButton from "../resources/profileButton.vue";
import SettingButton from "../resources/settingButton.vue";
import Palet from "../resources/palet.vue";

import SelectOpenStorageModal from "@/commonComponents/alertModal/selectOpenStorageModal/selectOpenStorageModal.vue";
import IeAlertModal from "@/commonComponents/alertModal/ieAlertModal/ieAlertModal.vue";
import FontConvertModal from "@/commonComponents/alertModal/fontConvertModal/fontConvertModal.vue";
import FileOpenAlertModal from "@/commonComponents/alertModal/fileOpenAlertModal/fileOpenAlertModal.vue";
import TimeoutModal from "../../cloud/cloudModal/timeoutModal.vue";
import DeletedAccountModal from "../../cloud/cloudModal/deletedAccountModal.vue";
import DeleteAccountModal from "./deleteAccountModal/deleteAccountModal.vue";
import DeleteAccount from "./deleteAccount/deleteAccount.vue";
import LoadingScreen from "@/commonComponents/loadingScreen/loadingScreen.vue";
import MyPageModal from "@/views/cloud/cloudModal/myPageModal.vue";
import ForgotPasswordModal from "@/views/signIn/inputMail/inputMail.vue";
import ResetPasswordModal from "@/views/signIn/inputPassword/inputPassword.vue";
import AskConvert3dTextAlertModal from "@/commonComponents/alertModal/askConvert3dTextAlertModal/askConvert3dTextAlertModal.vue";

import { ResourceHelper } from "@/helper/resourceHelper";
import { UserAgentHelper } from "@/helper/userAgentHelper";
import { NativeHelper } from "@/helper/nativeHelper";
import { StringHelper } from "@/helper/stringHelper";
import { InitializeHelper } from "@/helper/initializeHelper";
import { CloudAccount } from "@/cloudAccount/cloudAccount";

import { Product } from '@/data/productCategory/product/product';
import { Paper } from '@/data/productCategory/product/paper/paper';
import { FontManager } from '@/model/fontManager/fontManager';
import { DocumentHelper } from "@/helper/documentHelper";

import parseJSON from '@/helper/parseJson';
import ChangePasswordModal from '../../cloud/cloudModal/changePasswordModal.vue';
import platform from '@/helper/platform';
import { PathHelper } from '@/helper/pathHelper';

@Component({
  components: {
    FileOpen2,
    MultiFileConverter,
    Profile,
    InsertionModal,
    NewsView,
    Import,
    FileOpenButton,
    CreateNew,
    Book,
    Palet,
    ProfileButton,
    SettingButton,
    ColorSkin,
    License,
    SelectOpenStorageModal,
    IeAlertModal,
    FontConvertModal,
    FileOpenAlertModal,
    TimeoutModal,
    DeletedAccountModal,
    DeleteAccountModal,
    CloudSigninBalloon,
    CloudSignoutBalloon,
    DeleteAccount,
    LoadingScreen,
    MyPageModal,
    ChangePasswordModal,
    ForgotPasswordModal,
    ResetPasswordModal,
    AskConvert3dTextAlertModal
  }
})
export default class MainContents extends Vue {
    isProfileVisible = false;
    isPlugConfirmVisible = false;
    isFileOpenAlertModal = false;
    isLicense = false;
    isIeAlertModal = false;
    isTimeoutModal = false;
    isDeletedAccountModal = false;
    isCloudSigninBalloon = false;
    isCloudSignoutBalloon = false;
    isDeleteAccountModal = false;
    isDeleteAccount = false;

    isOpenDocumentModalVisibled = false;
    isImportDocumetInsertionModalVisibled = false;

    isLoadingScreenVisible = false;

    // モーダルを閉じた時のコールバック処理
    private callbackInClosingModal : null | (() => void) = null;

    newsList: News[] = []

    mounted()
    {
        this.loadNews();
        this.loadAccount();
        // 当面はIEでは必ず表示する
        if(UserAgentHelper.getBrowser() == "ie"
        && (!CookieHelper.hasItem("ieAlertShown") || CookieHelper.hasItem("ieAlertShown") && CookieHelper.getItem("ieAlertShown") == false)){
            this.isIeAlertModal = true;
        }

        if(CookieHelper.getItem("license") != true){
            this.isLicense = true;
        }

        let openFileIfNeeded = () =>
        {
            if (this.$store.state.openingFile) 
            {
                const file = this.$store.state.openingFile;
                this.openFile(file.path, file.data, true);
                // 開いたら初期化する
                this.$store.state.openingFile = null;
            }
        };

        if(this.isIeAlertModal || this.isLicense)
        {
            // IEアラート or ライセンスを表示するためローディングを消す
            this.$emit("destroyLoadingScreen");
            // アラートを非表示したらファイル読み込み処理を行う
            this.callbackInClosingModal = openFileIfNeeded;
        }
        else
        {
            // ファイル読み込み処理を直ちにおこなう
            openFileIfNeeded();
        }

        // メッセージセンター登録
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.subscribe(this, "exec_command", this.processExecCommand);
    }

    private destroyed()
    {
        // メッセージセンター削除
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.unsubscribe(this, "exec_command");
    }

    // コマンド処理
    // DL版で呼び出す
    private processExecCommand(paramParent : any)
    {
        try
        {
            var command : string = paramParent.command;
            var parameter : any = paramParent.parameter;

            if(command == "import_document")
            {
                // ドキュメント読み込み

                // 読み込み中モーダル表示
                this.isOpenDocumentModalVisibled = false;
                this.isImportDocumetInsertionModalVisibled = false;
                this.isLoadingScreenVisible = true;
                this.$nextTick(() =>
                {
                    var doc = FileHelper.loadDocumentAnyway(parameter.document);
                    if(doc != null)
                    {
                        let filePath = parameter.filePath;
                        let fileName = parameter.fileName != null ? parameter.fileName : "";
                        doc.currentFilePath = filePath;
                        doc.openedFileName = fileName;

                        // オープン
                        var filename = FileHelper.getFullBaseName(filePath);
                        // フォントコンバート対応
                        FontManager.applyUnloadedFontsToDocument(doc);
                        if(doc.unloadedFonts.length > 0)
                        {
                            // 利用できないフォントがあった場合
                            var fontConvertModal = this.$refs.fontConvertModal as FontConvertModal;
                            // フォントモーダルを開き、OKが押されたときにドキュメントロードする
                            this.isLoadingScreenVisible = false;
                            fontConvertModal.open(doc.unloadedFonts,
                            () =>
                            {
                                if(doc != null)this.loadDocument(doc, filename, true);
                            });
                        }
                        else
                        {
                            this.loadDocument(doc, filename, true);
                        }
                    }
                    else
                    {
                        this.isLoadingScreenVisible = false;
                        // ファイルが読めなかったダイアログを表示する
                        this.$emit("showFileErrorMessage");
                    }
                });
            }
            else if(command == "import_label9_document")
            {
                // ラベル9ドキュメント読み込み

                // 読み込み中モーダル表示
                this.isOpenDocumentModalVisibled = false;
                this.isImportDocumetInsertionModalVisibled = false;
                this.isLoadingScreenVisible = true;
                this.$nextTick(() =>
                {
                    let documentBuf = parameter.document;
	                let filePath = parameter.filePath;
	                let fileName = parameter.fileName != null ? parameter.fileName : "";

	                let doc = FileHelper.loadDocumentFromLabel9(documentBuf, this.$store.getters.fontManager);
                    if(doc != null)
                    {
                        doc.currentFilePath = filePath;
                        doc.openedFileName = fileName;

                        // 完了処理
                        let completion = () =>
                        {
                            // オープン
                            if(doc != null)
                            {
                                // ラベル屋さん9の3D文字のコンバート対応
                                if(DocumentHelper.contains3dTextLayers(doc)) {
                                    this.isLoadingScreenVisible = false;
                                    (this.$refs.askConvert3dTextAlertModal as AskConvert3dTextAlertModal).open(ret => {
                                        if(doc == null) return;
                                        this.isLoadingScreenVisible = true;
                                        if(ret) {
                                            DocumentHelper.convert3dTextLayersToSimpleTextLayers(doc);
                                        }
                                        let filename = FileHelper.getFullBaseName(filePath);
                                        this.loadDocument(doc, filename, true);
                                    })
                                } else {
                                    let filename = FileHelper.getFullBaseName(filePath);
                                    this.loadDocument(doc, filename, true);
                                }
                            }
                            else
                            {
                                this.isLoadingScreenVisible = false;
                            }
                        };

                        if(doc.unloadedFonts.length > 0)
                        {
                            // 利用できないフォントがあった場合
                            var fontConvertModal = this.$refs.fontConvertModal as FontConvertModal;
                            // フォントモーダルを開き、OKが押されたときにドキュメントロードする
                            this.isLoadingScreenVisible = false;
                            fontConvertModal.open(doc.unloadedFonts,
                            () =>
                            {
                                this.isLoadingScreenVisible = true;
                                completion();
                            });
                        }
                        else
                        {
                            completion();
                        }
                    }
                    else
                    {
                        this.isLoadingScreenVisible = false;
                        // ファイルが読めなかったダイアログを表示する
                        this.$emit("showFileErrorMessage");
                    }
                });
            }
        }
        catch(ex)
        {
            DebugHelper.trace(ex);
        }
    }

    /***************************************************************************
     * アカウント管理の制御
     **************************************************************************/

    mail = "";
    accountForm = {
        needsRecommend: ""
    };

    loadAccount() {
        const params = {
            action: "show",
            authorizationToken : CookieHelper.getItem("authorizationToken"),
            accessToken : CookieHelper.getItem("accessToken"),
            platformId : String(platform.id),
        };
        RequestHelper.post("questionnaire", params, (response) => {
            const json = JSON.parse(response);
            DebugHelper.trace(json);
            if (json.status) {
                DebugHelper.trace("アンケート情報を取得できませんでした。");
                return;
            }
            this.accountForm = {
                needsRecommend: json.data.needsRecommend ? "on" : ""
            };
        }, () => {
            DebugHelper.trace("アンケート情報を取得できませんでした。");
        });
    }

    isAccountModalOpened = false;
    isChangePasswordModalOpened = false;
    isForgotPasswordModalOpened = false;
    isResetPasswordModalOpened = false;

    private is_bad_access_token_result(checkRes) {
        if(checkRes){
            if(checkRes == "timeout"){
                this.isTimeoutModal = true;
                this.cloudAccount.isSignIn = false;
                this.cloudAccount.signOutType = 3;
            }
            else if(checkRes == "deletedAccount"){
                // アカウントが消えているモーダルを出す
                this.isDeletedAccountModal = true;
                this.cloudAccount.isSignIn = false;
                this.cloudAccount.signOutType = 1;
            }
            DebugHelper.trace(checkRes);
            return true;
        }
        return false;
    }

    manageAccount() {
        CloudHelper.checkAccessToken((checkRes) => {
            if (this.is_bad_access_token_result(checkRes)) return;

            var param = {
                authorizationToken : CookieHelper.getItem("authorizationToken"),
                accessToken : CookieHelper.getItem("accessToken"),
                platformId : String(platform.id)
            }

            RequestHelper.post("get_user_detail", param, (response) => {
                var res : any = JSON.parse(response);
                DebugHelper.trace(res);
                if(res.message.length > 0){
                    this.isError = true;
                    this.errorMessages = new Array();
                    for(var i = 0; i < res.message.length; i++){
                        this.errorMessages.push({index: i, message: res.message[i]});
                    }
                }
                else{
                    this.mail = res.data.mail;
                    this.isAccountModalOpened = true;
                }
            }, () => {
                DebugHelper.trace("エラー");
            });
        })
    }

    onDoCommand(command: string, payload: any) {
        switch (command) {
            case "changePassword":
                this.isChangePasswordModalOpened = true;
                this.isAccountModalOpened = false;
                return;
            case "changeNeedsRecommend":
                this.changeNeedsRecommend(payload);
                return;
            case "cansel":
                // 誤字は原作通り
                this.isError = false;
                this.errorMessages = [];
                this.isChangePasswordModalOpened = false;
                return;
            case "savePassword":
                this.savePassword(payload);
                return;
            case "forgot":
                this.isError = false;
                this.errorMessages = [];
                this.isForgotPasswordModalOpened = true;
                this.isChangePasswordModalOpened = false;
                return;
            case "returnPage":
                this.isForgotPasswordModalOpened = false;
                this.isResetPasswordModalOpened = false;
                return;
            case "sendMail":
                this.sendMail(payload);
                return;
            case "reregistrationPassword":
                this.reregistrationPassword(payload);
                return;
        }
    }

    isError = false;
    errorMessages: { index: number, message: string }[] = [];

    // TODO cloud.vueと共通化したい
    savePassword(form) {
        CloudHelper.checkAccessToken((checkRes) => {
            if (this.is_bad_access_token_result(checkRes)) return;

            var param = {
                authorizationToken : CookieHelper.getItem("authorizationToken"),
                accessToken : CookieHelper.getItem("accessToken"),
                platformId : String(platform.id),
                oldPassword : form.oldPassword,
                password : form.password,
                rePassword : form.rePassword
            }

            RequestHelper.post("get_user_edit_password", param, (response) => {
                var res : any = JSON.parse(response);
                DebugHelper.trace(res);
                if(res.message.length > 0){
                    this.isError = true;
                    this.errorMessages = [];
                    for(var i = 0; i < res.message.length; i++){
                        this.errorMessages.push({index: i, message: res.message[i]});
                    }
                }
                else{
                    this.isError = false;
                    this.errorMessages = [];
                    this.isChangePasswordModalOpened = false;
                }
            }, () => {
                DebugHelper.trace("エラー");
            });
        })
    }

    // パスワード忘れた時のワンタイムパス発行
    sendMail(params: any) {
        CloudHelper.checkAccessToken((checkRes) => {
            if (this.is_bad_access_token_result(checkRes)) return;

            RequestHelper.post("send_reset_onetime", params, (response) => {
                var res : any = JSON.parse(response);
                DebugHelper.trace(res);
                if(res.message.length > 0){
                    this.isError = true;
                    this.errorMessages = [];
                    for(var i = 0; i < res.message.length; i++){
                        this.errorMessages.push({index: i, message: res.message[i]});
                    }
                }
                else{
                    CookieHelper.setItem("certificationToken", res.data.certificationToken);
                    this.isError = false;
                    this.errorMessages = [];
                    this.isForgotPasswordModalOpened = false;
                    this.isResetPasswordModalOpened = true;
                }
            }, () => {
                DebugHelper.trace("エラー");
            });
        })
    }

    // ワンタイムパスでパスワードの再設定
    reregistrationPassword(param: any){
        CloudHelper.checkAccessToken((checkRes) => {
            if (this.is_bad_access_token_result(checkRes)) return;

            RequestHelper.post("reset_password", param, (response) => {
                var res : any = JSON.parse(response);
                DebugHelper.trace(res);
                if(res.message.length > 0){
                    this.isError = true;
                    this.errorMessages = new Array();
                    for(var i = 0; i < res.message.length; i++){
                        this.errorMessages.push({index: i, message: res.message[i]});
                    }
                }
                else{
                    CookieHelper.setItem("authorizationToken", res.data.authorizationToken);
                    CookieHelper.setItem("accessToken", res.data.accessToken);
                    CookieHelper.setItem("refreshToken", res.data.refreshToken);
                    CookieHelper.setItem("accessLimit", res.data.accessLimit);
                    CookieHelper.setItem("refreshLimit", res.data.refreshLimit);
                    this.isError = false;
                    this.errorMessages = new Array();
                    this.isResetPasswordModalOpened = false;
                }
            }, () => {
                DebugHelper.trace("エラー");
            });
        })
    }

    changeNeedsRecommend(needsRecommend: boolean) {
        CloudHelper.checkAccessToken((checkRes) => {
            if (this.is_bad_access_token_result(checkRes)) return;
            const payload = {
                action: "change_needs",
                authorizationToken : CookieHelper.getItem("authorizationToken"),
                accessToken : CookieHelper.getItem("accessToken"),
                platformId : String(platform.id),
                needsRecommend: needsRecommend ? "1" : "0"
            };
            RequestHelper.post("questionnaire", payload, res => {
                const json = JSON.parse(res);
                if (json.status) {
                    alert(json.message.join("\n"));
                    return;
                }
                const msg = needsRecommend ? "メールの配信を有効化しました。" : "メールの配信を無効化しました。";
                alert(msg);
            }, ()=> {
                DebugHelper.trace("配信設定を保存できませんでした。");
            });
        });
    }

    @Watch("cloudAccount.isSignIn")
        changeIsSignIn(){
            if(!this.cloudAccount.isSignIn && this.cloudAccount.signOutType == 2){
                this.isTimeoutModal = true;
                this.cloudAccount.signOutType = 3;
                // モーダルを出すため読み込み中を消去
                this.$emit("destroyLoadingScreen");
            }
        }

    private get cloudAccount() : CloudAccount
    {
      	return this.$store.getters.cloudAccount;
    }

    private get isDebugMode(){
        return DebugHelper.isDebugMode;
    }

    private fileOpenButtonClick()
    {
        // アプリフローを通常にする
        var applicationState = this.$store.getters.applicationState;
        applicationState.flowMode = 0;

        // if(this.isDebugMode)
        // {
            this.isOpenDocumentModalVisibled = true;
        // }
        // else
        // {
        //     this.onOpenDocumentModalSelected();
        // }
    }

    public createNewDocument()
    {
        this.$store.dispatch("setPageTransition", "newCreateFile");

        // アプリフローを通常にする
        var applicationState = this.$store.getters.applicationState;
        applicationState.flowMode = 0;

        // デフォルトの商品・用紙
        var rootData : Data = this.$store.getters.data;
        var product = rootData.selectedProduct;
        var paper = rootData.selectedPaper;
        // 新規ドキュメントを作成
        var document = Document.create(product, paper);

        // 1ページ目を取得する。なければ作る
        var firstPage = document.pageList.length <= 0 ? document.createNewPage() : document.pageList[0];
        if(document.pageList.length <= 0)
        {
            document.addPage(firstPage);
        }

        // 新規デザインをテンプレートなしで作成して表面のposition = 0にする
        firstPage.getSurface(false).createNewDesign(0);

        // 作成したドキュメントを差し替える
        this.$store.dispatch("setDocument", document);
        DebugHelper.trace(document);

        // ハッシュ初期化
        document.updateHash();

        LogHelper.sendLog("110", null);

        //用紙選択に遷移
        this.$router.push("/SelectPage");
    }

    private openFile(path, data, isAssociated : boolean = false)
    {
        var isFontConvertModalVisible = false;
        // 拡張子で振り分ける
        let ext = FileHelper.getFileExtension(path);
        let doc : Document | null = null;
        let isLabel9 = ext == "lcx" || ext == "lcxt";
        if(isLabel9)
        {
            // label9読み込み
            if(data instanceof Uint8Array)
            {
                // dataがUint8Arrayだった場合ArrayBufferに変換する
                let ab = data.buffer;
                doc = FileHelper.loadDocumentFromLabel9(ab, this.$store.getters.fontManager);
            }
            else if(data instanceof ArrayBuffer)
            {
                doc = FileHelper.loadDocumentFromLabel9(data, this.$store.getters.fontManager);
            }
        }
        else
        {
            doc = FileHelper.loadDocumentAnyway(data);
        }
        if(doc != null)
        {
            // ファイルパス・ファイル名保持
            doc.openedFileName = FileHelper.getFullBaseName(path);
            doc.currentFilePath = path;

            FontManager.applyUnloadedFontsToDocument(doc);

            let load_document = () => {
                if(doc == null) return;
                // ラベル屋さん9の3D文字のコンバート対応
                if(isLabel9 && DocumentHelper.contains3dTextLayers(doc)) {
                    this.$emit("destroyLoadingScreen");
                    (this.$refs.askConvert3dTextAlertModal as AskConvert3dTextAlertModal).open(ret => {
                        if(doc == null) return;
                        if(ret) {
                            DocumentHelper.convert3dTextLayersToSimpleTextLayers(doc);
                        }
                        this.$emit("showLoadingScreen");
                        this.$nextTick(() => { if(doc != null) this.loadDocument(doc, path, false, isAssociated); });
                    })
                } else {
                    this.loadDocument(doc, path, false, isAssociated);
                }
            };

            if(doc.unloadedFonts.length > 0)
            {
                // 利用できないフォントがあった場合
                var fontConvertModal = this.$refs.fontConvertModal as FontConvertModal;
                if(fontConvertModal != null)
                {
                    // フォントモーダルを開き、OKが押されたときにドキュメントロードする
                    this.isLoadingScreenVisible = false;
                    isFontConvertModalVisible = true;
                    // フォントモーダルを出すため、Topで出している読み込み中のモーダルは非表示にする
                    this.$emit("destroyLoadingScreen");
                    fontConvertModal.open(doc.unloadedFonts,
                    () =>
                    {
                        // 読み込み中モーダルを復帰する
                        this.$emit("showLoadingScreen");
                        this.$nextTick(() => load_document());
                    });
                }
            }

            if(!isFontConvertModalVisible)
            {
                // フォントモーダルを出さない場合はそのままドキュメントロード
                load_document();
            }
        }
        else
        {
            // ドキュメントの読み込みに失敗しているので、Topで出している読み込みモーダルを非表示
            this.$emit("destroyLoadingScreen");
            // ファイルが読めなかったダイアログを表示する
            this.$emit("showFileErrorMessage");
        }
    }

    private onMultiLabel9TextSelected(text : string, name : string)
    {
        var fileConverter = new FileConverter(this.$store.getters.fontManager);
        var document = fileConverter.deserializeLabel9FromXml(text);

        if(document == null) { return; }

        // ドキュメントにエラーがあればファイル名を err_###.project とする。
        var rename = document.hasError() ? "err_" + name : name;
        var filename = rename;

        //!! 複数の場合はサムネイルを生成すると遅くなるので作らない。
        //!! また、Rendererは1つしかインスタンスを作成していないので、問題が出そう。

        // documentをダウンロードする
        FileHelper.saveDocumentAsZip(document, filename);
    }

    // ドキュメントのロード
    private loadDocument(document : Document, fileName : string = "", isOpenedFileNameIgnored : boolean = false, isAssociated : boolean = false)
    {
        var finish = () =>
        {
            this.loadDocumentCore(document, fileName, isOpenedFileNameIgnored, isAssociated);
        }

        InitializeHelper.getProductAndPaperFromPaperCode(this.$store.getters.data.productCategoryList, document.paperCode, (product : Product, paper : Paper, categoryId : number, hierarchy : number) =>
        {
            // アプリ全体の用紙選択情報を更新する
            this.$store.getters.data.selectedProduct = product;
            this.$store.getters.data.selectedPaper = paper;
            this.$store.getters.data.paperDirection = Math.round(document.rotate / 90);
            this.$store.getters.data.selectTemplateCategory(categoryId, hierarchy);

            //! ラベル9コンバートのときのバグ(修正済み)のため
            //! 読み込みのときに用紙情報からラベル枠線画像を復旧する
            var isFixed = false;
            for(var i = 0; i < document.frameArray.length; ++i)
            {
                var frame = document.frameArray[i];
                var shape = frame.shape;
                if(shape.hasFaceImage && shape.faceImage == "")
                {
                    // フレームのSVG画像表示フラグがONであるのに、画像データがない場合は、修正をする
                    if(paper.frameInfoList != null && i < paper.frameInfoList.length)
                    {
                        var frameInfo = paper.frameInfoList[i];
                        var shapeInfo = frameInfo.shapeInfo;
                        if(shapeInfo.imageFormat == 0)
                        {
                            var frontTag = CompatibleHelper.convertCompressedEncodedImageToSvg(shapeInfo.frontFxg);
                            if(frontTag != null && frontTag != "")
                            {
                                // データをbase64SVGに変換する *バックレイヤー削除
                                shape.faceImage = ImageHelper.convertSVGTagToBase64(CompatibleHelper.removeBacklayerFromSvg(frontTag));
                                isFixed = true;
                            }
                        }
                    }
                }
                if(shape.hasReverseImage && shape.reverseImage == "")
                {
                    // フレームのSVG画像表示フラグがONであるのに、画像データがない場合は、修正をする
                    if(paper.frameInfoList != null && i < paper.frameInfoList.length)
                    {
                        var frameInfo = paper.frameInfoList[i];
                        var shapeInfo = frameInfo.shapeInfo;
                        if(shapeInfo.imageFormat == 0)
                        {
                            var backTag = CompatibleHelper.convertCompressedEncodedImageToSvg(shapeInfo.backFxg);
                            if(backTag != null && backTag != "")
                            {
                                // データをbase64SVGに変換する *バックレイヤー削除
                                shape.reverseImage = ImageHelper.convertSVGTagToBase64(CompatibleHelper.removeBacklayerFromSvg(backTag));
                                isFixed = true;
                            }
                        }
                    }
                }
            }

            if(isFixed)
            {
                DebugHelper.trace("Frame images are fixed.")
                // 全ての面に対して用紙情報を再反映する
                for(var pageIdx = 0; pageIdx < document.pageCount; ++pageIdx)
                {
                    var page = document.pageList[pageIdx];
                    for(var surfaceIdx = 0; surfaceIdx < page.surfaces.length; ++surfaceIdx)
                    {
                        var surface = page.surfaces[surfaceIdx];
                        for(var idx = 0; idx < surface.frameArray.length; ++idx)
                        {
                            if(idx < document.frameArray.length)
                            {
                                surface.frameArray[idx].shape.faceImage = document.frameArray[idx].shape.faceImage;
                                surface.frameArray[idx].shape.reverseImage = document.frameArray[idx].shape.reverseImage;
                            }
                        }
                    }
                }
            }


            finish();
        }, () =>
        {
            finish();
        });
    }

    private loadDocumentCore(document : Document, fileName : string = "", isOpenedFileNameIgnored : boolean = false, isAssociated : boolean = false)
    {
        // ファイル名保持
        if(!isOpenedFileNameIgnored) document.openedFileName = fileName;

        var applicationState = this.$store.getters.applicationState;

        if(isAssociated)
        {
            // DL版で関連付けから開いた場合のログ
            LogHelper.sendLog("20", {
                productId : document.productId,
                code : document.paperCode,
                version : Const.LABELYASAN_TEN_VERSION
            });
        }
        else
        {
            var logValue = {
                productId : document.productId,
                code : document.paperCode,
                cloud : 0
            };
            //ファイルを開いたときにそのファイルの品番をログで送る
            LogHelper.sendLog("100" , logValue);
        }

        if(applicationState.flowMode == 2)
        {
            // 差し込みドキュメントから連番レイヤーを削除する
            InsertionHelper.removeNumberLayerFromDocument(document);
            // 差し込みドキュメントセット
            this.$store.getters.userConfig.insertionDocument = document;

            // 新規ドキュメント作成
            var newDocument = Document.createFromDocument(document);
            // ドキュメントを差し替える
            this.$store.dispatch("setDocument", newDocument);

            // アプリフローが差し込みの読み込みだった場合はデザイン選択に遷移
            this.$router.push("/SelectInsertionDesign");
        }
        else if(document.useInsertion)
        {
            // ドキュメントを差し替える
            this.$store.dispatch("setDocument", document);

            // アプリフローを差し込みにする
            applicationState.flowMode = 3;

            // 差し込みに遷移
            this.$router.push("/InsertionEditor");
        }
        else
        {
            // ドキュメントを差し替える
            this.$store.dispatch("setDocument", document);

            // アプリフローを通常にする
            applicationState.flowMode = 0;

            // レイアウトエディターに遷移
            this.$router.push("/LayoutEditor");
        }
    }

    toUsage(){
        window.open('https://labelten.labelyasan.com/web/help/index.html', '_blank');
    }

    // 差し込み
    private onInsertionModalSelected(type)
    {
        // 閉じる
        this.isPlugConfirmVisible = false;
        if(type == "template")
        {
            // テンプレート

            // アプリフローを差し込みモード(テンプレート)にする
            var applicationState = this.$store.getters.applicationState;
            applicationState.flowMode = 1;
            // ドキュメントの差し込みデータを初期化

            // 新規
            this.$router.push("/SelectPage");
        }
        else if(type == "importDocument")
        {
            // アプリフローを通常にする
            var applicationState = this.$store.getters.applicationState;
            applicationState.flowMode = 2;

            // if(this.isDebugMode)
            // {
                this.isImportDocumetInsertionModalVisibled = true;
            // }
            // else
            // {
            //     this.onImportDocumentInsertionModalSelected();
            // }
        }
    }

    // 通常のドキュメント - ローカル読み込み
    private onOpenDocumentModalSelected()
    {
        if(UserAgentHelper.isElectron())
        {
            // DL版はネイティブで開く
            NativeHelper.sendNativeEvent("request_open_document", {});
            return;
        }

        // ドキュメント開く
        var fileOpen = this.$refs.fileOpen2 as FileOpen2;
        fileOpen.open(FileOpen2.FILETYPE_DOCUMENT, args =>
        {
            // 読み込み中モーダルを復帰する
            this.$emit("showLoadingScreen");
            this.openFile(args.fileName, args.data, false);
        });
    }

    // 差し込みのドキュメント読み込み - ローカル読み込み
    private onImportDocumentInsertionModalSelected()
    {
        // flowModeで判定させるので、通常の開くと同じ処理
        this.onOpenDocumentModalSelected();
    }

    private closeIeAlertModal()
    {
        this.isIeAlertModal = false;
        this.$nextTick(() => {
            if(this.callbackInClosingModal)
            {
                this.callbackInClosingModal();
                this.callbackInClosingModal = null;
            }
        });
    }

    private closeLicenseModal(){
        this.isLicense = false;
        this.$nextTick(() => {
            if(!UserAgentHelper.isElectron()){
                this.isCloudSigninBalloon = true;
            }
            if(this.callbackInClosingModal) 
            {
                this.callbackInClosingModal();
                this.callbackInClosingModal = null;
            }
        })
    }

    private doDeleteAccount(){
        CloudHelper.checkAccessToken((checkRes) => {
            if(checkRes){
                if(checkRes == "timeout"){
                    this.isTimeoutModal = true;
                    this.cloudAccount.isSignIn = false;
                    this.cloudAccount.signOutType = 3;
                    return;
                }
                else if(checkRes == "deletedAccount"){
                    // アカウントが消えているモーダルを出す
                    this.isDeletedAccountModal = true;
                    this.cloudAccount.isSignIn = false;
                    this.cloudAccount.signOutType = 1;
                    return;
                }
                DebugHelper.trace(checkRes);
                return;
            }

            var param = {
                uuid : CookieHelper.hasItem("authorizationToken") ? CookieHelper.getItem("authorizationToken") : ""
            };

            RequestHelper.post("request_delete", param, (response) => {
                var res : any = JSON.parse(response);
                DebugHelper.trace(res);
                if(res.message.length > 0){
                    DebugHelper.trace(res.message);
                }
                else{
                    this.isDeleteAccount = true;
                }
            }, () => {
                DebugHelper.trace("エラー");
            });
        })
    }

    private closeTimeoutModal(){
        this.isTimeoutModal = false;
        this.isDeleteAccount = false;
    }

    private closeDeletedAccountModal(){
        this.isDeletedAccountModal = false;
        this.isDeleteAccount = false;
    }

    // debug
    private convertLabel9Document()
    {
        var fileOpen = this.$refs.multiFileOpen as MultiFileConverter;
        fileOpen.open();
    }

    seeAllNews(){
        let routeData = this.$router.resolve({name: 'newsAll'});
        window.open(routeData.href, '_blank');
    }

    isColorSkinVisible = false;

    //configcolor
    private get userConfigColors(){
        return this.$store.getters.userConfigColors;
    }

    private get buttonColorStyle(){
        return {
            "background-color" : this.userConfigColors.buttonColorCode
        }
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }

    /**
     * トップページのニュースを用意する
     */
    private loadNews() {
        newsApi.getTopNews().then(news => {
            this.newsList = news;
        });
    }
}
